// .pen p3uE9(cover 叠层)+ m1lbb(pkgBadge)— 订阅/分享列表卡片共用。
// 结构:48×48 容器,绝对定位:背景色卡(41×41 圆角12,按 id 稳定取色,偏右上)+
// 42×42 封面图(白描边2,偏左下,无封面时色卡+Package icon 占位)+ 右下 20×20 白底 package 角标。
import { Package } from 'lucide-react'
import { resourceUrl } from '../_lib/resource-node-pref'

const BACK_COLORS = ['#BBD5FB', '#A7E8CF', '#FFC9C9', '#FFE5B4', '#E6CCFF', '#C9E4DE']

/** 按 id 稳定取色:同一个包每次渲染颜色一致 */
export function packBackColor(id: string): string {
  let h = 0
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
  return BACK_COLORS[h % BACK_COLORS.length]!
}

export function PackCoverThumb({ packId, coverUrl }: { packId: string; coverUrl: string | null }) {
  const back = packBackColor(packId)
  return (
    <span data-testid="p3uE9" className="relative block h-12 w-12 shrink-0">
      <span className="absolute left-[7px] top-[1px] h-[41px] w-[41px] rounded-xl" style={{ backgroundColor: back }} />
      <span
        className="absolute left-0 top-[5px] flex h-[42px] w-[42px] items-center justify-center overflow-hidden rounded-xl ring-2 ring-white"
        style={{ backgroundColor: back }}
      >
        {coverUrl ? (
          <img src={resourceUrl(coverUrl)} alt="" className="h-full w-full object-cover" />
        ) : (
          <Package size={18} className="text-white/80" aria-hidden="true" />
        )}
      </span>
      <span
        data-testid="m1lbb"
        className="absolute left-[29px] top-[30px] flex h-5 w-5 items-center justify-center rounded-[10px] bg-white shadow-[0_1px_3px_rgba(0,0,0,0.15)]"
      >
        <Package size={12} className="text-[#3B82F6]" aria-hidden="true" />
      </span>
    </span>
  )
}
